import { StoreDataTypeKey } from '@etoh/database/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

export const getAddLink = (dataType: StoreDataTypeKey): string => {
  return `/features/${dataType}/add`;
};

interface ExtractedField {
  key: string;
  type: string;
  subType: string;
  required: boolean;
}

export const extractKeysAndTypes = (
  fieldsToExtract: FormlyFieldConfig[]
): ExtractedField[] => {
  const extractedFields: {
    key: string;
    type: string;
    subType: string;
    required: boolean;
  }[] = [];

  function extract(fields: FormlyFieldConfig[]) {
    fields.forEach((field) => {
      if (field.key && field.type) {
        extractedFields.push({
          key: field.key as string,
          type: field.type as string,
          subType: field?.props?.type as string,
          required: field?.props?.required as boolean,
        });
      }
      if (field.fieldGroup) {
        extract(field.fieldGroup);
      }
    });
  }

  extract(fieldsToExtract);
  return extractedFields;
};
